import React, { useReducer } from 'react';
import orderProcessService from '../services/orderProcess';

interface Props {
  children: any
}

const FormDataContext = React.createContext(null);

const actionsConst = {
  SET_PERSONAL: 'SET_PERSONAL',
  SET_DELIVERY_INFO: 'SET_DELIVERY_INFO',
  SET_OTHER_PERSON_INFO: 'SET_OTHER_PERSON_INFO',
};

const initialValue = {
  personal: {
    fieldAnrede: 'Herr',
    fieldName: '',
    fieldFirstname: '',
    fieldAhvNumber: '',
    fieldDob: null,
    fieldAddress: '',
    fieldAddressNotFound: false,
    fieldStrasse: '',
    fieldNr: '',
    fieldPlz: '',
    fieldOrt: '',
    fieldLand: 'Schweiz',
    fieldPhone: '',
    fieldEmail: '',
    uploadfield: undefined,
    fieldRemarks:''
  },
  otherPersonInfo: {
    OfieldAnrede: 'Herr',
    OfieldName: '',
    OfieldFirstname: '',
    OfieldDob: null,
    fieldAddress: '',
    fieldAddressNotFound: false,
    fieldStrasse: '',
    fieldNr: '',
    fieldPlz: '',
    fieldOrt: '',
    fieldLand: 'Schweiz',
  },
  deliveryInfo: {
    fieldDeliveryAddressDifferent: false,
    fieldDeliveryCompany: '',
    fieldDeliveryLastname: '',
    fieldDeliveryFirstname: '',
    fieldAddress: '',
    fieldAddressNotFound: false,
    fieldStrasse: '',
    fieldNr: '',
    fieldPlz: '',
    fieldOrt: '',
    fieldLand: 'Schweiz',
  },
};

const reducer = (state, action) => {
  const {
    type,
    payload,
  } = action;

  switch (type) {
    case actionsConst.SET_PERSONAL: {
      return {
        ...state,
        personal: payload,
      };
    }

    case actionsConst.SET_DELIVERY_INFO: {
      const { deliveryInfo } = state;
      return {
        ...state,
        deliveryInfo: {
          ...deliveryInfo,
          ...payload,
        },
      };
    }

    case actionsConst.SET_OTHER_PERSON_INFO: {
      const { otherPersonInfo } = state;
      return {
        ...state,
        otherPersonInfo: {
          ...otherPersonInfo,
          ...payload,
        },
      };
    }
    default:
      return state;
  }
};

const FormDataContextProvider = ({ children }: Props) => {
  const [state, dispatch] = useReducer(reducer, initialValue);

  function setPersonal(personal) {
    dispatch({
      type: actionsConst.SET_PERSONAL,
      payload: personal,
    });
  }

  function setDeliveryInfo(deliveryInfo) {
    dispatch({
      type: actionsConst.SET_DELIVERY_INFO,
      payload: deliveryInfo,
    });
  }

  function setOtherPersonInfo(otherPersonInfo) {
    dispatch({
      type: actionsConst.SET_OTHER_PERSON_INFO,
      payload: otherPersonInfo,
    });
  }

  function fetchFormData(documentId) {
    return orderProcessService.fetchOrderDetails(documentId)
      .then((res) => {
        if (res) {
          dispatch({
            type: actionsConst.SET_PERSONAL,
            payload: res?.formData?.personal,
          });
          dispatch({
            type: actionsConst.SET_DELIVERY_INFO,
            payload: res?.formData?.deliveryInfo,
          });
          dispatch({
            type: actionsConst.SET_OTHER_PERSON_INFO,
            payload: res?.formData?.otherPersonInfo,
          });
        }
        return res;
      });
  }

  const contextValue = {
    state,
    setPersonal,
    setDeliveryInfo,
    setOtherPersonInfo,
    fetchFormData,
    dispatch,
  };

  return (
    <FormDataContext.Provider
      value={contextValue}
    >
      { children }
    </FormDataContext.Provider>
  );
};

FormDataContextProvider.defaultProps = {
  children: '',
};

export default { FormDataContext, FormDataContextProvider, actionsConst };
